import React, { useEffect, useState } from 'react';

export default function SuccessScreen({ insightsUrl, totalQuestions }) {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (!insightsUrl) return;

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          // Try redirect — use window.open as fallback for iframes
          try {
            window.location.href = insightsUrl;
          } catch (e) {
            window.open(insightsUrl, '_blank');
          }
          // If we're still here after 500ms (blocked by iframe), try open
          setTimeout(() => {
            try { window.open(insightsUrl, '_blank'); } catch (e2) { /* noop */ }
          }, 500);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [insightsUrl]);

  return (
    <div className="view on" data-testid="success-screen" style={{ textAlign: 'center', flex: 1, overflowY: 'auto' }}>
      <div style={{ marginBottom: '40px' }}>
        <div className="tension-track" style={{ height: '4px', borderRadius: '2px' }}>
          <div className="tension-fill" style={{ width: '100%', background: 'var(--teal)' }} />
        </div>
        <div className="hint-text" style={{ marginTop: '8px' }}>{totalQuestions || 57} of {totalQuestions || 57} — Complete</div>
      </div>

      <div style={{ fontSize: '48px', marginBottom: '24px', color: 'var(--teal)' }}>&#10003;</div>
      <h1 data-content="survey.success_title" style={{ marginBottom: '16px' }}>Assessment Complete</h1>
      <p className="desc" data-content="survey.success_subtitle" style={{ marginBottom: '32px', maxWidth: '520px', margin: '0 auto 32px' }}>
        Your responses have been submitted successfully. Your personalised AI readiness report is being generated.
      </p>

      {insightsUrl && countdown > 0 && (
        <p className="dim" style={{ marginBottom: '24px' }}>
          Redirecting to your Insights Portal in {countdown} seconds...
        </p>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '32px' }}>
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--teal)', animation: 'pulse 1.4s ease-in-out infinite' }} />
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--teal)', animation: 'pulse 1.4s ease-in-out 0.2s infinite' }} />
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--teal)', animation: 'pulse 1.4s ease-in-out 0.4s infinite' }} />
      </div>

      <div
        className="guide-card"
        style={{ textAlign: 'left', maxWidth: '480px', margin: '0 auto 32px' }}
      >
        <h3 style={{ marginBottom: '12px' }}>What happens next?</h3>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', marginBottom: '12px' }}>
            <span style={{ color: 'var(--teal)', fontWeight: 600, flexShrink: 0 }}>1.</span>
            <span className="dim">Your responses are being scored across 12 dimensions of AI readiness.</span>
          </li>
          <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', marginBottom: '12px' }}>
            <span style={{ color: 'var(--teal)', fontWeight: 600, flexShrink: 0 }}>2.</span>
            <span className="dim">A personalised report with your maturity profile, strengths, and growth areas is being assembled.</span>
          </li>
          <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', marginBottom: '12px' }}>
            <span style={{ color: 'var(--teal)', fontWeight: 600, flexShrink: 0 }}>3.</span>
            <span className="dim">You will be redirected to your AI Navigator Insights portal to view your results.</span>
          </li>
          <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <span style={{ color: 'var(--teal)', fontWeight: 600, flexShrink: 0 }}>4.</span>
            <span className="dim">A confirmation email with your portal link will also be sent to your inbox.</span>
          </li>
        </ul>
      </div>

      {insightsUrl && (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
          <a
            href={insightsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-p"
            style={{ display: 'inline-block', maxWidth: '320px', width: '100%', textDecoration: 'none', textAlign: 'center' }}
            data-testid="insights-portal-btn"
          >
            Go to Insights Portal &rarr;
          </a>
        </div>
      )}

      <p className="hint-text" style={{ maxWidth: '480px', margin: '0 auto' }}>
        {insightsUrl
          ? 'If you are not redirected automatically, click the button above or check your email.'
          : 'You can close this window. Your results will be available at insights.ai-explorer.com.au once the portal is live.'}
      </p>
    </div>
  );
}
